<template>
  <v-form
    ref="form"
    :lazy-validation="true"
     @submit.prevent="onSave" >

    <div class="button-group">
      <h2>Contact Information</h2>
      <button
        v-if="!editing"
        class="default-btn blue padded short"
        @click="editing = true"
      >Edit</button>
    </div>

    <div class="input-grid">
      <label :class="{ editing }">Full Name</label>
      <v-text-field
        v-if="editing"
        v-model="user.fullName"
        single-line
        solo
        :rules="validateName"
        validate-on-blur
      ></v-text-field>
      <span v-else class="info-field">{{ user.fullName }}</span>

      <label :class="{ editing }">Email</label>
      <v-text-field
        v-if="editing"
        v-model="user.email"
        single-line
        solo
        :rules="validateEmail"
        validate-on-blur
      ></v-text-field>
      <span v-else class="info-field">{{ user.email }}</span>
    </div>

    <div v-if="editing" class="button-group">
      <button
        class="default-btn green padded short"
        :disabled="saving"
        @click="onSave"
      >Save</button>
      <button
        class="default-btn text padded short"
        @click="onCancel"
      >Cancel</button>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { formMixin } from '@/mixins'

export default {
  name: 'UserEditForm',
  mixins: [formMixin],
  props: {
  },
  data: () => ({
    editing: false,
    user: {
      id: '',
      fullName: '',
      email: '',
    },
    saving: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiUsers']),
    ...mapState('authStore', {
      userData: 'userData',
    }),
  },
  watch: {
    userData () {
      this.resetUserData()
    },
  },
  mounted () {
    this.resetUserData()
  },
  methods: {
    ...mapActions('authStore', ['setUserData']),

    resetUserData () {
      this.user = {
        id: this.userData.id,
        fullName: this.userData.fullName,
        email: this.userData.email,
      }
    },

    onCancel () {
      this.editing = false
      this.resetUserData()
    },

    async onSave () {
      if (!this.$refs.form.validate()) return
      this.saving = true

      try {
        const userData = await this.apiUsers.patch(this.user.id, this.user)
        this.setUserData(userData)

        this.editing = false
        this.addAlert({ message: 'User info updated!' })
      } catch (err) {
        this.addAlert({
          type: 'error',
          message: `There was an error when updating your information: ${err.message}`,
        })
      }

      this.saving = false
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  width: 100%;

  .info-field {
    font-family: "Sansation Regular", Serif;
    font-size: 16px;
    line-height: 18px;
    color: $textDarkMuted;
  }
}

h2 + button {
  align-self: flex-start;
}

.button-group:first-child {
  grid-column-gap: 20px;

  grid-template-columns: 1fr auto;
}
</style>
